var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CollaboratorTicket, PacketTicket, PaymentMethod, Ticket } from '../../Reports/Model';
import { EResult } from '../Store';
import { typeList } from '../../Reports/Store';
export var all = {
    allBusiness: 'allBusiness',
    allAfiliates: 'allAfiliates',
    allDiscounts: 'allDiscounts',
    allCategories: 'allCategories'
};
export var Range = {
    Custom: 'custom',
    Today: 'day',
    Week: 'week',
    Month: 'month',
    Year: 'year'
};
export var TerminalSale = {
    Api: 'api',
    Web: 'web',
    Virtual: 'virtual',
    POS: 'pos'
};
export var ListBy = {
    DateSale: 'ds',
    DateUse: 'du'
};
export var DataListBy = {
    ds: typeList.Report,
    du: typeList.Calendar
};
export var Filter = {
    ListBy: 'lb',
    Owner: 'owner',
    Collaborator: 'collaborator',
    TerminalSale: 'ts',
    Operator: 'o',
    Stretch: 's',
    CollaboratorStretch: 'cs',
    User: 'user',
    Servicio: 'servicio',
    CollaboratorService: 'cs',
    CollaboratorPacket: 'cp',
    Packet: 'p',
    LineaOperacion: 'operationLine',
    CategoriaPasajero: 'categoriaPasajero',
    Afiliate: 'a',
    DiscountReason: 'discountReason',
    Clients: 'clients'
};
export var mapea = function (tickets, state) {
    // console.log('mapea - tickets: ', tickets)
    var result = {
        total: {
            sales: 0,
            tickets: 0,
            ticketsCollaborator: 0,
            ticketsService: 0,
            ticketsPacket: 0,
            checkins: 0,
            creditSales: 0,
            canceled: 0,
            creditSalesCanceled: 0,
            discount: 0
        },
        operarios: {},
        lineasOperacion: {},
        packets: {},
        servicesInPackets: {},
        servicios: {},
        collaboratorServices: {},
        afiliados: {},
        discountReasons: {},
        categories: {}
    };
    if (tickets.length > 0) {
        result.total.tickets = tickets.length; // TODO repasar por si se están añadiendo los rectificados
        tickets.forEach(function (ticket) {
            // compruebo si está cancelado o descuento
            /*if (ticket.daterefund) {
              result.total.tickets--
              return
            }*/
            // inicializo
            var temp = {
                ticketsService: 0,
                ticketsPacket: 0,
                ticketsCollaborator: 0
            };
            if (ticket instanceof PacketTicket) { // ticket de un paquete
                temp.ticketsService = 0;
                temp.ticketsCollaborator = 0;
                temp.ticketsPacket = 1;
            }
            else if (ticket instanceof CollaboratorTicket) { // ticket en colaboración (de otro prestador)
                temp.ticketsService = 0;
                temp.ticketsCollaborator = 1;
                temp.ticketsPacket = 0;
            }
            else { // ticket de servicio propio
                temp.ticketsService = 0;
                temp.ticketsCollaborator = 1;
                temp.ticketsPacket = 0;
            }
            var operario = __assign(__assign({ sales: 0, tickets: 1 }, temp), { checkins: 0, canceled: 0 });
            var lineaOperacion = __assign(__assign({ sales: 0, tickets: 1 }, temp), { checkins: 0, canceled: 0 });
            var servicio = __assign(__assign({ sales: 0, tickets: 1 }, temp), { checkins: 0, canceled: 0 });
            var collaboratorService = __assign(__assign({ sales: 0, tickets: 1 }, temp), { checkins: 0, canceled: 0 });
            var paquete = __assign(__assign({ sales: 0, tickets: 1 }, temp), { checkins: 0, canceled: 0 });
            var categoria = __assign(__assign({ sales: 0, tickets: 0 }, temp), { checkins: 0, canceled: 0 });
            var afiliado = { sales: 0, tickets: 0, ticketsService: 0, ticketsCollaborator: 0, ticketsPacket: 0, checkins: 0, creditSales: 0, canceled: 0 };
            var discountReason = { sales: 0, tickets: 0, ticketsService: 0, ticketsCollaborator: 0, ticketsPacket: 0, checkins: 0, canceled: 0, discount: 0, discountCanceled: 0 };
            if (ticket.daterefund && !ticket.corrected_id) { // ticket cancelado método antiguo
                result.total.canceled += ticket.total;
                operario.canceled += ticket.total;
                lineaOperacion.canceled += ticket.total;
                if (ticket instanceof PacketTicket) {
                    paquete.canceled += ticket.total;
                }
                else if (ticket instanceof CollaboratorTicket) {
                    collaboratorService.canceled += ticket.total;
                }
                else {
                    servicio.canceled += ticket.total;
                }
                if (ticket.totalDiscount > 0) {
                    discountReason.canceled += ticket.total;
                    discountReason.tickets++;
                    discountReason.discountCanceled += ticket.totalDiscount;
                    result.total.discountCanceled += ticket.totalDiscount;
                }
            }
            else if (ticket.refund_id) { // ticket que rectifica a otro, lo ignoro
            }
            else {
                operario.sales += ticket.total;
                lineaOperacion.sales += ticket.total;
                if (ticket instanceof PacketTicket) {
                    paquete.sales += ticket.total;
                }
                else if (ticket instanceof CollaboratorTicket) {
                    collaboratorService.sales += ticket.total;
                }
                else {
                    servicio.sales += ticket.total;
                }
                if (ticket.totalDiscount > 0) {
                    discountReason.sales += ticket.total;
                    discountReason.tickets++;
                    discountReason.discount += ticket.totalDiscount;
                    result.total.discount += ticket.totalDiscount;
                }
            }
            if (ticket.lines.length > 0) {
                ticket.lines.forEach(function (line) {
                    operario.checkins += line.quantity;
                    lineaOperacion.checkins += line.quantity;
                    if (ticket instanceof PacketTicket) {
                        paquete.checkins += line.quantity;
                    }
                    else if (ticket instanceof CollaboratorTicket) {
                        collaboratorService.checkins += line.quantity;
                    }
                    else {
                        servicio.checkins += line.quantity;
                    }
                    if (ticket.totalDiscount > 0) {
                        discountReason.checkins += line.quantity;
                    }
                    // Categories
                    var categoryName = line.passengerCategoryName;
                    if (result.categories[categoryName]) { // ya está
                        // console.log('categories - ya está', `${categoryName} - antes: `, result.categories[categoryName].checkins)
                        result.categories[categoryName].checkins += line.quantity;
                        // console.log('categories - ya está', `${categoryName} - despues: `, categoria.checkins)
                    }
                    else {
                        // console.log('categories - no está', `${categoryName} - antes: `, line.quantity)
                        categoria.checkins = line.quantity;
                        // console.log('categories - no está', `${categoryName} - despues: `, categoria.checkins)
                        result.categories[categoryName] = categoria;
                    }
                    if (!ticket.daterefund && !ticket.refund_id && line.passengerCategoryName === state.categorySelected) {
                        result.total.checkins += line.quantity;
                    }
                });
            }
            result.total.sales = result.total.sales + operario.sales;
            if (state.categorySelected === all.allCategories) { // sólo si se han cogido todas las categorías
                result.total.checkins = result.total.checkins + operario.checkins;
            }
            // Operarios
            var username;
            if (ticket.username) {
                username = ticket.username;
            }
            else {
                username = ticket.user.username;
            }
            mapeaIResult(EResult.Operarios, result, operario, username);
            // Lineas operacion
            mapeaIResult(EResult.LineasOperacion, result, lineaOperacion, ticket.operationLineName);
            // Servicios
            if ((ticket instanceof Ticket) && !(ticket instanceof CollaboratorTicket) && !(ticket instanceof PacketTicket)) {
                mapeaIResult(EResult.Servicios, result, servicio, ticket.stretchName);
            }
            // Paquetes
            if (ticket instanceof PacketTicket) {
                mapeaIResult(EResult.Packets, result, paquete, ticket.packetName);
            }
            // tickets en colaboración
            if (ticket instanceof CollaboratorTicket) {
                mapeaIResult(EResult.CollaboratorServices, result, collaboratorService, ticket.stretchName);
            }
            // Descuentos
            if (ticket.totalDiscount > 0) {
                var discountReasonName = ticket.discountReason || 'other';
                if (discountReasonName.toLowerCase() === 'peluqueria mari') {
                    console.log('id: ', ticket.id);
                }
                mapeaIResult(EResult.DiscountReasons, result, discountReason, discountReasonName, true);
            }
            // Afiliados credito
            if (ticket.payments) {
                var afiliadoName_1;
                ticket.payments.forEach(function (payment) {
                    if (payment.method === PaymentMethod.Credit) {
                        afiliadoName_1 = payment.afiliateName;
                        if (result.afiliados[afiliadoName_1]) { // ya está
                            // console.log(`${ticket.id} - ya está ${afiliadoName} - amount: `, payment.amount)
                            afiliado = result.afiliados[afiliadoName_1];
                            // console.log('afiliado: ', JSON.stringify(afiliado))
                            if ((ticket.daterefund)) { // cancelado y sin ticket que lo corrige (cancelación antigua
                                // console.log('cancelado - YA ESTÁ, amount: ', payment.amount)
                                afiliado.canceled += payment.amount;
                                result.total.creditSalesCanceled = result.total.creditSalesCanceled + Math.abs(payment.amount);
                            }
                            else if (ticket.refund_id) {
                                // console.log('refund_id, no hago nada - YA ESTÁ')
                            }
                            else {
                                // console.log('no cancelado - YA ESTÁ, amount: ', payment.amount)
                                // console.log(`sumo a ${afiliadoName} la cantidad de: ${payment.amount}`)
                                afiliado.creditSales += payment.amount;
                                afiliado.sales += payment.amount;
                                afiliado.tickets++;
                                // console.log('afiliado.creditSales: ', JSON.stringify(afiliado.creditSales))
                                // console.log('añado a result.total.creditSales la cantidad de: ', payment.amount)
                                result.total.creditSales += payment.amount;
                                ticket.lines.forEach(function (line) {
                                    afiliado.checkins += line.quantity;
                                });
                            }
                        }
                        else { // no está
                            // console.log(`${ticket.id} - no está ${afiliadoName} - amount: `, payment.amount)
                            if ((ticket.daterefund)) { // cancelado y sin ticket que lo corrige (cancelación antigua)
                                // console.log('cancelado - NO ESTÁ, amount: ', payment.amount)
                                afiliado.canceled = Math.abs(payment.amount);
                                result.total.creditSalesCanceled = Math.abs(payment.amount);
                            }
                            else if (ticket.refund_id) { // es el que corrige al cancelado (método nuevo, ni a sales ni a canceled) que tiene daterefund
                                // console.log('refund_id, no hago nada - NO ESTÁ')
                            }
                            else {
                                // console.log('no cancelado - NO ESTÁ, amount: ', payment.amount)
                                // console.log(`sumo a ${afiliadoName} la cantidad de: ${payment.amount}`)
                                afiliado.creditSales = payment.amount;
                                afiliado.sales = payment.amount;
                                afiliado.tickets++;
                                ticket.lines.forEach(function (line) {
                                    afiliado.checkins += line.quantity;
                                });
                                // console.log('añado a result.total.creditSales la cantidad de: ', payment.amount)
                                result.total.creditSales += payment.amount;
                            }
                        }
                        // console.log(`añado a result afiliado: `, JSON.stringify(afiliado))
                        result.afiliados[afiliadoName_1] = afiliado;
                        // console.log('**********************************************')
                    }
                });
            }
        });
    }
    // console.log('result.afiliados: ', JSON.stringify(result.afiliados))
    // console.log('mapea - result: ', result)
    return result;
};
export var mapeaVouchers = function (vouchers, state) {
    /*
    Para los voucher el criterio es:
    si el voucher tiene boxPayments quiere decir que no se cobró el total en origen y se ha cobrado parte en destino
    la parte que se cobra en origen es a crédito, el resto en los distintos métodos de pago (cash o card)
     */
    var result = {
        total: {
            vouchers: 0,
            receipt_total: 0,
            amount_paid: 0,
            vouchersCanceled: 0,
            receipt_totalCanceled: 0,
            amount_paidCanceled: 0,
            booked: 0,
            rebooked: 0,
            checkins: 0,
            credit: 0,
            cash: 0,
            card: 0,
            transfer: 0,
            other: 0,
            totalPaidDestination: 0
        }
    };
    if (vouchers && vouchers.length > 0) {
        result.total.vouchers = vouchers.length;
    }
    vouchers.forEach(function (voucher) {
        // console.log('voucher: ', voucher)
        // TODO hay que comprobar que cuando se modifica una reserva
        // TODO status cambia a rebooked
        if (voucher.status === 'booked') {
            result.total.booked++;
            result.total.receipt_total += voucher.receipt_total / 100;
            result.total.amount_paid += voucher.amount_paid / 100;
            if (voucher.boxPayments) { // se ha cobrado el total por diversos métodos
                var boxPayments = typeof voucher.boxPayments === 'string' ? JSON.parse(voucher.boxPayments) : voucher.boxPayments;
                boxPayments.forEach(function (boxPayment) {
                    switch (boxPayment.method) {
                        case PaymentMethod.Cash:
                            result.total.cash += boxPayment.amount;
                            result.total.totalPaidDestination += boxPayment.amount;
                            break;
                        case PaymentMethod.Card:
                            result.total.card += boxPayment.amount;
                            result.total.totalPaidDestination += boxPayment.amount;
                            break;
                        case PaymentMethod.Transfer:
                            result.total.transfer += boxPayment.amount;
                            result.total.totalPaidDestination += boxPayment.amount;
                            break;
                        case PaymentMethod.Other:
                            result.total.other += boxPayment.amount;
                            result.total.totalPaidDestination += boxPayment.amount;
                            break;
                        case PaymentMethod.Credit:
                            result.total.credit += boxPayment.amount;
                            break;
                        default:
                    }
                });
            }
            else {
                // puede suceder:
                //    * Que esté abonado totalmente
                //    * Que quede una parte o el total por abonar en destino
                // en cualquier caso de momento controlamos lo cobrado, lo pendiente no
                // amount_paid es a credito
                result.total.credit += voucher.amount_paid / 100;
            }
        }
        else if (voucher.status === 'rebooked') {
            result.total.rebooked++;
        }
        else if (voucher.status === 'canceled') {
            result.total.vouchersCanceled++;
            result.total.receipt_totalCanceled += voucher.receipt_total;
            result.total.amount_paidCanceled += voucher.amount_paid;
        }
        result.total.checkins += voucher.lines.length; // cada linea es un pasajero
    });
    // console.log('mapeaVouchers result: ', result)
    return result;
};
var mapeaIResult = function (eResult, result, subResult, name, withDiscount) {
    if (result[eResult][name]) { // ya está
        var oldValue = result[eResult][name];
        subResult.sales += oldValue.sales;
        subResult.tickets += oldValue.tickets;
        subResult.checkins += oldValue.checkins;
        if (withDiscount) {
            subResult.totalDiscount += oldValue.totalDiscount;
            subResult.discountCanceled += oldValue.discountCanceled;
        }
    }
    // console.log(`result[${eResult}][${name}]: `, result[eResult][name])
    result[eResult][name] = subResult;
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/DashboardTicket/Util/Mapea.ts
// module id = 95
// module chunks = 0